import { render, staticRenderFns } from "./Facture.vue?vue&type=template&id=d53c3142&scoped=true&"
import script from "./Facture.vue?vue&type=script&lang=js&"
export * from "./Facture.vue?vue&type=script&lang=js&"
import style0 from "./Facture.vue?vue&type=style&index=0&id=d53c3142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c3142",
  null
  
)

export default component.exports